import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    color: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingVertical: 53,
    paddingLeft: 53,
    paddingRight: 10,
  },
  rightColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingVertical: 53,
    paddingLeft: 10,
    paddingRight: 53,
  },
  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
  },

  paragraphWrapper: {
    marginTop: 20,
    marginBottom: 40,
  },
  paragraph: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 18,
  },

  multiTouchPointWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    width: '100%',
    flexWrap: 'wrap',
    paddingBottom: 40,
  },
  multiTouchPointItem: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#EEEEEE',
    borderRadius: '8px',
    width: '100%',
  },
  imageWrapper: {
    width: '100%',
    height: 170,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    alignSelf: 'flex-start',
    padding: '12px',
    width: '100%',
  },
  itemTitle: {
    breakWord: 'word-break',
    color: '#27343d',
    fontSize: 13,
    fontFamily: 'Lato',
    fontWeight: 900,
    marginBottom: 10,
  },
  itemSubtitle: {
    breakWord: 'word-break',
    color: '#27343d',
    fontSize: 12,
    fontFamily: 'Lato',
    lineHeight: 1.5,
  },
});
